<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      max-width="450"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <v-flex xs12 px-2>
            <v-select
              v-model="localFilters.typeRanking"
              :items="typesRanking"
              :label="$t('titles.global.typeRanking')"
            />
          </v-flex>
          <v-flex xs12 px-2>
            <type-event-field
              v-model="localFilters.typeEventId"
              type="official"
              :label="$tc('models.typeEvent')"
              vote
            />
          </v-flex>
          <v-flex xs12 md9 px-2>
            <category-menu
              v-model="localFilters.categoryId"
              clearable
              :label="$tc('models.category')"
            />
          </v-flex>
          <v-flex v-if="localFilters.categoryId" md3 xs12 px-2>
            <v-text-field
              v-model="localFilters.session"
              type="number"
              :label="$tc('fields.matches.session')"
            />
          </v-flex>
          <v-flex xs12 px-2>
            <entity-field
              v-model="localFilters.entityId"
              is-customer
              :label="$tc('models.entity')"
            />
          </v-flex>

          <v-flex xs12 px-2>
            <team-field
              v-model="localFilters.teamId"
              :entity-id="localFilters.entityId"
              :category-id="localFilters.categoryId"
              is-customer
              :label="$t('fields.matches.homeTeam')"
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <date-picker
              v-model="localFilters.dateStart"
              :label="$t('fields.tournaments.startAt')"
            />
          </v-flex>

          <v-flex xs12 md6 px-2>
            <date-picker
              v-model="localFilters.dateEnd"
              :label="$t('fields.tournaments.endAt')"
            />
          </v-flex>
          <!-- Filtro fechas -->
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn color="primary" flat @click="search">
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import DatePicker from '@/components/widgets/Input/DatePicker'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
import TypeEventField from '@/components/widgets/Input/TypeEventField'

export default {
  name: 'TopVotingFilters',
  components: {
    CategoryMenu,
    TeamField,
    EntityField,
    DatePicker,
    TypeEventField,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data: () => ({
    menu: false,
  }),
  computed: {
    typesRanking() {
      return [
        { value: 'score', text: this.$t('titles.global.votes') },
        { value: 'rate', text: this.$t('titles.global.average') },
      ]
    },
    localFilters: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    search() {
      this.menu = false
      this.$emit('search')
    },
  },
}
</script>
